import React from 'react';
import { cn } from '../utils';

export interface FormControlProps {
  label?: string;
  labelAlt?: string;
  helperText?: string;
  error?: string;
  warning?: string;
  success?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const FormControl: React.FC<FormControlProps> = ({
  label,
  labelAlt,
  helperText,
  error,
  warning,
  success,
  required,
  children,
  className,
}) => {
  return (
    <div className={cn('form-control', className)}>
      {label && (
        <label className="label pb-2">
          <span className="label-text">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </span>
          {labelAlt && <span className="label-text-alt">{labelAlt}</span>}
        </label>
      )}

      {children}

      {(helperText || error || warning || success) && (
        <label className="label">
          <span
            className={cn(
              'label-text-alt',
              error && 'text-error',
              warning && 'text-warning',
              success && 'text-success'
            )}
          >
            {error || warning || success || helperText}
          </span>
        </label>
      )}
    </div>
  );
};
